<main class="main">
  <app-cart-list></app-cart-list>
  <ng-container *ngIf="cartWithProducts$ | async as cart">
    <app-resume *ngIf="cart.length > 0"></app-resume>
  </ng-container>
</main>
